import { Button, Content } from 'rsuite';
import styles from './styles.module.scss';

type ResultsButtonProps = {
  onClick: () => void;
  hasDataRendered: boolean;
  disabled?: boolean;
};

export const ResultsButton = ({ onClick, hasDataRendered, disabled = false }: ResultsButtonProps) => (
  <Content className={styles.resultButtonContent}>
    <Button id="elasticidade-results-button" appearance="primary" className={styles.resultButton} onClick={onClick} disabled={disabled}>
      {hasDataRendered ? 'ATUALIZAR RESULTADOS' : 'VISUALIZAR RESULTADOS'}
    </Button>
  </Content>
);
